import { BaseModel } from '../../../../../../core/_base/crud';

	export class DeNghiNhapKho extends BaseModel {

		static category_path = "PTTHV";

		static optionsTinhTrang = [
			{
				id: 1,
				name: 'Đang soạn thảo',
				value: 'PTTHV_PHIEUMOI',
				defaultChecked: true,
			},
			{
				id: 2,
				name: 'Đang thực hiện',
				value: 'PTTHV_CHOKQKT',
				defaultChecked: true,
			},
			{
				id: 3,
				name: 'Hoàn tất',
				value: 'PTTHV_HOANTAT',
				defaultChecked: false,
			},
			{
				id: 4,
				name: 'Đã hủy',
				value: 'PTTHV_DAHUY',
				defaultChecked: false,
			},
			{
				id: 5,
				name: 'Chờ kiểm tra',
				value: 'PTTHV_CHOKIEMTRA',
				defaultChecked: true,
			},
			{
				id: 6,
				name: 'Trả hàng',
				value: 'PTTHV_TRAHANG',
				defaultChecked: false,
			}
		];

		static optionsLoaiPhieu = [
			{
				value: 0,
				name: 'Hàng từ KH trả về',
			},
			{
				value: 1,
				name: 'Hàng từ NCC giao',
			},
			{
				value: 2,
				name: 'Hàng từ đi xử lý về',
			}
		];

		IdDn: number
		Sophieu: string
		Ngaynhap: string
		Nguoitao: number
		TenNguoitao: string
		Ngaytao: string
		Nguoisua: number
		Ngaysua: string
		Tinhtrang: string
		TenTinhTrang: string
		Type: boolean
		Ghichu: string
		Nguoiduyet: number
		TenNguoiduyet: string
		Ngayduyet: string
		Lydokhongduyet: string
		attachmentId: number
		BoPhanDeNghi: number
		TenBoPhanDeNghi: string
		Lydonhap: string
		isQCKiemTra: boolean
		LoaiPhieu: number
		listChiTietNhapKho: DeNghiNhapKhoChiTiet[]
		listDenghinhapkhoLsthaotac: DenghinhapkhoLsthaotac[]
		listFileDinhKem: FileDinhKem[]
		FileImport: DSFileImport
		IsVisible_Duyet: boolean = false
		IsEnable_Duyet: boolean = false
		Data_Duyet: any[]

		numChoKT: number;
		numChoTPDuyetKQ: number;
		numChoGDCLDuyetKQ: number;
		numHoanTat: number;

		clear() {
			this.IdDn = 0;
			this.Sophieu = '';
			this.Ngaynhap = '';
			this.Nguoitao = 0;
			this.TenNguoitao = '';
			this.Ngaytao = '';
			this.Nguoisua = 0;
			this.Ngaysua = '';
			this.Tinhtrang = '';
			this.TenTinhTrang = '';
			this.Type = false;
			this.Ghichu = '';
			this.Nguoiduyet = 0;
			this.TenNguoiduyet = '';
			this.Ngayduyet = '';
			this.Lydokhongduyet = '';
			this.attachmentId = 0;
			this.BoPhanDeNghi = 0;
			this.TenBoPhanDeNghi = '';
			this.Lydonhap = '';
			this.isQCKiemTra = false;
			this.LoaiPhieu = 1;
			this.listChiTietNhapKho = [];
			this.listDenghinhapkhoLsthaotac = [];
			this.listFileDinhKem = [];
			this.IsVisible_Duyet = false;
			this.IsEnable_Duyet = false;
			this.Data_Duyet = [];

			this.numChoKT = 0;
			this.numChoTPDuyetKQ = 0;
			this.numChoGDCLDuyetKQ = 0;
			this.numHoanTat = 0;
		}
		copy(item: DeNghiNhapKho) {
			this.IdDn = item.IdDn;
			this.Sophieu = item.Sophieu;
			this.Ngaynhap = item.Ngaynhap;
			this.Nguoitao = item.Nguoitao;
			this.TenNguoitao = item.TenNguoitao;
			this.Ngaytao = item.Ngaytao;
			this.Nguoisua = item.Nguoisua;
			this.Ngaysua = item.Ngaysua;
			this.Tinhtrang = item.Tinhtrang;
			this.TenTinhTrang = item.TenTinhTrang;
			this.Type = item.Type;
			this.Ghichu = item.Ghichu;
			this.Nguoiduyet = item.Nguoiduyet;
			this.TenNguoiduyet = item.TenNguoiduyet;
			this.Ngayduyet = item.Ngayduyet;
			this.Lydokhongduyet = item.Lydokhongduyet;
			this.attachmentId = item.attachmentId;
			this.BoPhanDeNghi = item.BoPhanDeNghi;
			this.TenBoPhanDeNghi = item.TenBoPhanDeNghi;
			this.Lydonhap = item.Lydonhap;
			this.listChiTietNhapKho = item.listChiTietNhapKho;
			this.listDenghinhapkhoLsthaotac = item.listDenghinhapkhoLsthaotac;
			this.listFileDinhKem = item.listFileDinhKem;
			this.isQCKiemTra = item.isQCKiemTra;
			this.LoaiPhieu = item.LoaiPhieu;
			this.IsVisible_Duyet = item.IsVisible_Duyet;
			this.IsEnable_Duyet = item.IsEnable_Duyet;
			this.Data_Duyet = item.Data_Duyet;
			this.numChoKT = item.numChoKT;
			this.numChoTPDuyetKQ = item.numChoTPDuyetKQ;
			this.numChoGDCLDuyetKQ = item.numChoGDCLDuyetKQ;
			this.numHoanTat = item.numHoanTat;
		}
	}
	export class DeNghiNhapKhoChiTiet extends BaseModel {

		static DEFAULT_NUMBER_VALUE = "0,00";
		static DEFAULT_NUMBER_VALUE_NUMBER = "0.00";
		static optionTrangThaiDetail = [
			{
				id: 1,
				name: 'Chờ kiểm tra',
				value: 'PTTHV_DETAIL_CHOXULY',
			},
			{
				id: 2,
				name: 'Không cần duyệt KQ',
				value: 'PTTHV_DETAIL_KODUYETKQ',
			},
			{
				id: 3,
				name: 'Chờ TP duyệt KQ',
				value: 'PTTHV_DETAIL_CHOTPDUYET',
			},
			{
				id: 4,
				name: 'Chờ TP QA duyệt KQ',
				value: 'PTTHV_DETAIL_CHOGDDUYET',
			},
			{
				id: 5,
				name: 'Hoàn tất',
				value: 'PTTHV_DETAIL_DADUYETKQ',
			},
			{
				id: 6,
				name: 'Đã hủy',
				value: 'PTTHV_DETAIL_HUY'
			},
			{
				id: 7,
				name: 'Chờ xác nhận',
				value: 'PTTHV_DETAIL_CHOXACNHAN'
			}
		]
		static optionsNguonPhatSinh = [
			{
				value: 'NPSLPTTHV_MUAHANG',
				name: 'Phát sinh - mua hàng',
			},
			{
				value: 'NPSLPTTHV_KETQUASANXUAT',
				name: 'Phát sinh - kết quả sản xuất',
			},
			{
				value: 'NPSLPTTHV_PBDENGHINHAPKHO',
				name: 'Phát sinh - phòng ban đề nghị nhập kho',
			},
			{
				value: 'NPSLPTTHV_DIXULY',
				name: 'Phát sinh - đi xử lý',
			},
			{
				value: 'NPSLPTTHV_KHTRA',
				name: 'Phát sinh - khách hàng trả',
			}
		];
		static optionQuyetDinhLoHang = [
			{
				value: 0,
				name: 'Pass nhập',
			},
			{
				value: 1,
				name: 'Pass tạm nhập',
			},
			{
				value: 2,
				name: 'Trả hàng',
			}
		]
		static optionQuyetDinhLoHangChange = [
			{
				value: 0,
				name: 'Pass nhập cả lô',
			},
			{
				value: 1,
				name: 'Pass tạm nhập cả lô',
			},
			{
				value: 2,
				name: 'Trả cả lô',
			},
			{
				value: 3,
				name: 'Trả 1 phần - nhập 1 phần',
			},
			{
				value: 4,
				name: 'Trả 1 phần - tạm nhập 1 phần',
			},
		]

		IdCtdn: number
		IdDn: number
		IdHh: number
		IdPO: number
		IdKho: number
		MaPO: string
		TenHH: string
		MaHH: string
		DungSai: number
		QuyCach: string
		CanPhieuKT: boolean
		PBGiamSat: number
		Dvt: number
		TenDVT: string
		Soluongkehoach: string
		Soluongchungtu: string
		Solo: string
		Sophieukiemtracl: string
		Nguoikiemtra: number
		TenNguoiKiemTra: string
		Ngaykiemtra: string
		Quyetdinhlohang: number
		Nguoinhanhang: number
		TenNguoiNhanHang: string
		IdNcc: number
		TenNCC: string
		MaNCC: string
		Tinhtrang: boolean
		Ghichulohang: string
		IdCtyc: number
		Ngaysanxuat: string
		Handung: string
		IdTs: number
		Sopo: string
		IdLo: number
		PbkiemTraId: number
		TenPBKiemTra: string
		IdNguon: number
		NguonPhatSinh: string
		GhiChuKetQuaKiemTra: string
		DaLapPhieuNhapKho: boolean
		LoaiPhieu: string;
		isShow: boolean = false
		listNV: any[]
		IsVisible_Duyet: boolean = false
		IsEnable_Duyet: boolean = false
		//Extends
		IdPhieuDH: number;
		IdDHCT: number;
		SoPhieuDN: string
		SoPhieuDNMH: string
		SoPhieuXK: string
		NgayLapPhieuDN: string
		SoPhieuDH: string;
		SoLuongDHM:string
		SoMay: string
		NgaySanXat: string
		SoLuongThucNhap: string
		SoLuongPhuHop: string
		SoLuongKhongPhuHop: string
		QuyetDinhTra: number
		KetQuaDuyet: number
		LyDo: string
		GhiChuTraHang: string
		TrangThaiPassHang: string
		PhuHop: boolean
		KhongPhuHop: boolean
		SoLuongTraHang: string
		ThoiGianHangVe: string
		xuatkho_ct_id: number
		SoLuongThucGiao: string
		DeNghiChuyenKho_Ct_Id: number
		MaSub: string
		id_kho: number
		KD_DatHang_Ct_Id: number
		vitrikho: string
		TrangThaiNhapKho: number
		IdKeHoachHangVe: number
		isNhapKhoNoiBo: boolean
		listIdNvXacNhan: any[]
		HanSuDungTheoThang: number;
		IdParent: number;
		KhoPhuHop: number;
		KhoKhongPhuHop: number;
		FlagHead: boolean;
		DvtQuyDoi: number
        TenDvtQuyDoi: string
        KhoiLuongQuyDoi: number
        listDVTInfo: any[]
		TagInfo: string[]
		DienGiaiMaster: string
		PalletText: string
		ExpiryDate: string
		ConfirmPallet: boolean
		SoXeSoMe: string
		MaThung: string
		SoChungTu: string
		ChungTuKemTheo: boolean
		SoPOKH: string
		SoPONCC: string
		//Hàng xử lý về
		HangDiXuLyVeItem: HangDiXuLyVe = new HangDiXuLyVe();
		//Phòng ban
		DNNK_BoPhanNhap: string
		DNNK_PhongBanDeNghi: string
		SoPhieuNhapKho: string
		isConfirmState: boolean
		NgayNhanHang: string
		NgayDongThung:string
		clear() {
			this.IdCtdn = 0;
			this.IdDn = 0;
			this.SoPhieuDN= '';
			this.SoPhieuDNMH = '';
			this.SoPhieuXK = '';
			this.NgayLapPhieuDN = '';
			this.IdHh = 0;
			this.IdPO = 0;
			this.IdKho = 0;
			this.MaPO = ''
			this.TenHH = '';
			this.MaHH = '';
			this.DungSai = 0;
			this.QuyCach = '';
			this.CanPhieuKT = false;
			this.PBGiamSat = 0;
			this.Dvt = 0;
			this.TenDVT = '';
			this.Soluongkehoach = DeNghiNhapKhoChiTiet.DEFAULT_NUMBER_VALUE_NUMBER;
			this.Soluongchungtu = DeNghiNhapKhoChiTiet.DEFAULT_NUMBER_VALUE_NUMBER;
			this.Solo = '';
			this.Sophieukiemtracl = '';
			this.Nguoikiemtra = 0;
			this.TenNguoiKiemTra = '';
			this.Ngaykiemtra = '';
			this.Quyetdinhlohang = -1;
			this.Nguoinhanhang = 0;
			this.TenNguoiNhanHang = '';
			this.IdNcc = 0;
			this.TenNCC = '';
			this.MaNCC = '';
			this.Tinhtrang = false;
			this.Ghichulohang = '';
			this.IdCtyc = 0;
			this.Ngaysanxuat = '';
			this.Handung = '';
			this.IdTs = 0;
			this.Sopo = '';
			this.IdLo = 0;
			this.PbkiemTraId = 0;
			this.TenPBKiemTra = '';
			this.IdNguon = 0;
			this.NguonPhatSinh = '';
			this.GhiChuKetQuaKiemTra = '';
			this.SoPhieuDH = '';
			this.IdPhieuDH = 0;
			this.IdDHCT = 0;
			this.DaLapPhieuNhapKho = false;
			this.LoaiPhieu = '';
			this.isShow = false;
			this.listNV = [];
			this.IsVisible_Duyet = false;
			this.IsEnable_Duyet = false;
			this.SoLuongDHM='';
			this.SoMay= '';
			this.NgaySanXat= '';
			this.SoLuongThucNhap = DeNghiNhapKhoChiTiet.DEFAULT_NUMBER_VALUE_NUMBER;
			this.SoLuongPhuHop = '';
			this.SoLuongKhongPhuHop = '';
			this.QuyetDinhTra = 1;
			this.KetQuaDuyet = 0;
			this.LyDo= '';
			this.GhiChuTraHang= '';
			this.TrangThaiPassHang= '';
			this.PhuHop = false;
			this.KhongPhuHop = false;
			this.SoLuongTraHang = DeNghiNhapKhoChiTiet.DEFAULT_NUMBER_VALUE_NUMBER;
			this.ThoiGianHangVe = '';
			this.xuatkho_ct_id = 0;
			this.SoLuongThucGiao = DeNghiNhapKhoChiTiet.DEFAULT_NUMBER_VALUE_NUMBER;
			this.DeNghiChuyenKho_Ct_Id = 0;
			this.MaSub = '';
			this.id_kho = 0;
			this.KD_DatHang_Ct_Id = 0;
			this.IdParent = -1;
			this.KhoPhuHop = 0;
			this.KhoKhongPhuHop = 0;
			this.vitrikho = '';
			this.TrangThaiNhapKho = 0;
			this.IdKeHoachHangVe = 0;
			this.isNhapKhoNoiBo = false;
			this.listIdNvXacNhan = [];
			this.HanSuDungTheoThang = 0;
			this.HangDiXuLyVeItem = new HangDiXuLyVe();
			this.HangDiXuLyVeItem.clear();
			this.FlagHead = false;
			this.DvtQuyDoi = 0;
            this.TenDvtQuyDoi = '';
            this.KhoiLuongQuyDoi = 0;
            this.listDVTInfo = [];
			this.TagInfo = [];
			this.DienGiaiMaster = '';
			this.PalletText = '';
			this.ExpiryDate = '';
			this.ConfirmPallet = false;
			this.SoXeSoMe = '';
			this.MaThung = '';
			this.SoChungTu = '';
			this.ChungTuKemTheo = false
			this.SoPOKH = ''
			this.SoPONCC = ''
			this.DNNK_PhongBanDeNghi = ''
			this.DNNK_BoPhanNhap = ''
			this.SoPhieuNhapKho = ""
			this.isConfirmState = false
			this.NgayNhanHang = ""
			this.NgayDongThung = ""
		}
		copy(item: DeNghiNhapKhoChiTiet) {
			this.IdCtdn = item.IdCtdn;
			this.IdDn = item.IdDn;
			this.SoPhieuDN= item.SoPhieuDN;
			this.SoPhieuDNMH = item.SoPhieuDNMH;
			this.SoPhieuXK = item.SoPhieuXK;
			this.NgayLapPhieuDN = item.NgayLapPhieuDN;
			this.IdHh = item.IdHh;
			this.IdPO = item.IdPO;
			this.IdKho = item.IdKho;
			this.MaPO = item.MaPO;
			this.TenHH = item.TenHH;
			this.MaHH = item.MaHH;
			this.DungSai = item.DungSai;
			this.QuyCach = item.QuyCach;
			this.CanPhieuKT = item.CanPhieuKT;
			this.PBGiamSat = item.PBGiamSat;
			this.Dvt = item.Dvt;
			this.TenDVT = item.TenDVT;
			this.Soluongkehoach = item.Soluongkehoach;
			this.Soluongchungtu = item.Soluongchungtu;
			this.Solo = item.Solo;
			this.Sophieukiemtracl = item.Sophieukiemtracl;
			this.Nguoikiemtra = item.Nguoikiemtra;
			this.TenNguoiKiemTra = item.TenNguoiKiemTra;
			this.Ngaykiemtra = item.Ngaykiemtra;
			this.Quyetdinhlohang = item.Quyetdinhlohang;
			this.Nguoinhanhang = item.Nguoinhanhang;
			this.TenNguoiNhanHang = item.TenNguoiNhanHang;
			this.IdNcc = item.IdNcc;
			this.TenNCC = item.TenNCC;
			this.MaNCC = item.MaNCC;
			this.Tinhtrang = item.Tinhtrang;
			this.Ghichulohang = item.Ghichulohang;
			this.IdCtyc = item.IdCtyc;
			this.Ngaysanxuat = item.Ngaysanxuat;
			this.Handung = item.Handung;
			this.IdTs = item.IdTs;
			this.Sopo = item.Sopo;
			this.IdLo = item.IdLo;
			this.PbkiemTraId = item.PbkiemTraId;
			this.TenPBKiemTra = item.TenPBKiemTra;
			this.IdNguon = item.IdNguon;
			this.NguonPhatSinh = item.NguonPhatSinh;
			this.GhiChuKetQuaKiemTra = item.GhiChuKetQuaKiemTra;
			this.SoPhieuDH = item.SoPhieuDH;
			this.IdPhieuDH = item.IdPhieuDH;
			this.IdDHCT = item.IdDHCT;
			this.DaLapPhieuNhapKho = item.DaLapPhieuNhapKho
			this.LoaiPhieu = item.LoaiPhieu;
			this.isShow = item.isShow;
			this.listNV = item.listNV;
			this.IsVisible_Duyet = item.IsVisible_Duyet;
			this.IsEnable_Duyet = item.IsEnable_Duyet;
			this.SoLuongDHM=item.SoLuongDHM;
			this.SoMay= item.SoMay;
			this.NgaySanXat= item.NgaySanXat;
			this.SoLuongThucNhap = item.SoLuongThucNhap;
			this.SoLuongPhuHop = item.SoLuongPhuHop;
			this.SoLuongKhongPhuHop = item.SoLuongKhongPhuHop;
			this.QuyetDinhTra =item.QuyetDinhTra;
			this.KetQuaDuyet = item.KetQuaDuyet;
			this.LyDo= item.LyDo;
			this.GhiChuTraHang= item.GhiChuTraHang;
			this.TrangThaiPassHang= item.TrangThaiPassHang;
			this.PhuHop = item.PhuHop;
			this.KhongPhuHop = item.KhongPhuHop;
			this.SoLuongTraHang  = item.SoLuongTraHang;
			this.ThoiGianHangVe = item.ThoiGianHangVe;
			this.xuatkho_ct_id = item.xuatkho_ct_id;
			this.SoLuongThucGiao = item.SoLuongThucGiao;
			this.DeNghiChuyenKho_Ct_Id = item.DeNghiChuyenKho_Ct_Id;
			this.MaSub = item.MaSub;
			this.id_kho = item.id_kho;
			this.KD_DatHang_Ct_Id = item.KD_DatHang_Ct_Id;
			this.IdParent = item.IdParent;
			this.KhoPhuHop = item.KhoPhuHop;
			this.KhoKhongPhuHop = item.KhoKhongPhuHop;
			this.vitrikho = item.vitrikho;
			this.TrangThaiNhapKho = item.TrangThaiNhapKho;
			this.IdKeHoachHangVe = item.IdKeHoachHangVe;
			this.isNhapKhoNoiBo = item.isNhapKhoNoiBo
			this.listIdNvXacNhan = item.listIdNvXacNhan;
			this.HanSuDungTheoThang = item.HanSuDungTheoThang;
			if(item.HangDiXuLyVeItem != null && item.HangDiXuLyVeItem != undefined)
				this.HangDiXuLyVeItem.copy(item.HangDiXuLyVeItem)
			this.DvtQuyDoi = item.DvtQuyDoi;
			this.TenDvtQuyDoi = item.TenDvtQuyDoi;
			this.KhoiLuongQuyDoi = item.KhoiLuongQuyDoi;
			this.listDVTInfo = item.listDVTInfo;
			this.TagInfo = [];
			if(item.TagInfo && item.TagInfo.length > 0){
				item.TagInfo.forEach(el => this.TagInfo.push(el))
			}
			this.DienGiaiMaster = item.DienGiaiMaster;
			this.PalletText = item.PalletText;
			this.ExpiryDate = item.ExpiryDate;
			this.ConfirmPallet = item.ConfirmPallet;
			this.SoXeSoMe = item.SoXeSoMe;
			this.MaThung = item.MaThung;
			this.SoChungTu = item.SoChungTu;
			this.ChungTuKemTheo = item.ChungTuKemTheo;
			this.SoPOKH = item.SoPOKH;
			this.SoPONCC = item.SoPONCC;
			this.DNNK_BoPhanNhap = item.DNNK_BoPhanNhap
			this.DNNK_PhongBanDeNghi = item.DNNK_PhongBanDeNghi
			this.SoPhieuNhapKho = item.SoPhieuNhapKho
			this.isConfirmState = item.isConfirmState
			this.NgayNhanHang = item.NgayNhanHang
			this.NgayDongThung = item.NgayDongThung
		}
	}
	export class DenghinhapkhoLsthaotac extends BaseModel{
		Id: number
		DeNghiNhapKhoId: number
		NguoiThaoTac: number
		TenNguoiThaoTac: string
		NgayThaoTac: string
		LoaiThaoTac: string
		GhiChu: string
		NoiDung: string
		DeNghiNhapKhoCtId: number

		clear(){
			this.Id = 0;
			this.DeNghiNhapKhoId = 0;
			this.NguoiThaoTac= 0;
			this.TenNguoiThaoTac ='';
			this.NgayThaoTac = '';
			this.LoaiThaoTac = '';
			this.GhiChu = '';
			this.NoiDung = '';
			this.DeNghiNhapKhoCtId = 0;
		}

		copy(item: DenghinhapkhoLsthaotac){
			this.Id = item.Id;
			this.DeNghiNhapKhoId = item.DeNghiNhapKhoId;
			this.NguoiThaoTac= item.NguoiThaoTac;
			this.TenNguoiThaoTac = item.TenNguoiThaoTac;
			this.NgayThaoTac = item.NgayThaoTac;
			this.LoaiThaoTac = item.LoaiThaoTac;
			this.GhiChu = item.GhiChu;
			this.NoiDung = item.NoiDung;
			this.DeNghiNhapKhoCtId = item.DeNghiNhapKhoCtId;
		}
	}
	export class KeHoachHangVe extends BaseModel {

		Id: number;
		NgayDeNghiGiaoHang: string;
		HangHoaId: number;
		MaHang: string;
		TenHang: string;
		QuyCach: string;
		DVT: number;
		TenDVT: string;
		SoLuong: string;
		LoaiHH: number;
		TenLoaiHH: string;
		IdNCC: number;
		MaNCC: string;
		TenNCC: string;
		GhiChu: string;
		IdPDH: number;
		SoPhieuDH: string;
		IdPB: number;
		TenPB: string;

		clear() {
			this.Id = 0;
			this.NgayDeNghiGiaoHang = '';
			this.HangHoaId = 0;
			this.MaHang = '';
			this.TenHang = '';
			this.QuyCach = '';
			this.DVT = 0;
			this.TenDVT = '';
			this.SoLuong = '';
			this.LoaiHH = 0;
			this.TenLoaiHH = '';
			this.IdNCC = 0;
			this.MaNCC = '';
			this.TenNCC = '';
			this.GhiChu = '';
			this.IdPDH = 0;
			this.SoPhieuDH = '';
			this.IdPB = 0;
			this.TenPB = '';
		}
		copy(item: KeHoachHangVe) {
			this.Id = item.Id;
			this.NgayDeNghiGiaoHang = item.NgayDeNghiGiaoHang;
			this.HangHoaId = item.HangHoaId;
			this.MaHang = item.MaHang;
			this.TenHang = item.TenHang;
			this.QuyCach = item.QuyCach;
			this.DVT = item.DVT;
			this.TenDVT = item.TenDVT;
			this.SoLuong = item.SoLuong;
			this.LoaiHH = item.LoaiHH;
			this.TenLoaiHH = item.TenLoaiHH;
			this.IdNCC = item.IdNCC;
			this.MaNCC = item.MaNCC;
			this.TenNCC = item.TenNCC;
			this.GhiChu = item.GhiChu;
			this.IdPDH = item.IdPDH;
			this.SoPhieuDH = item.SoPhieuDH;
			this.IdPB = item.IdPB;
			this.TenPB = item.TenPB;
		}
	}
	export class FileDinhKem extends BaseModel {
		IdFile: number;
		FileName: string;
		GhiChu: string;

		clear() {
			this.IdFile = 0;
			this.FileName = '';
			this.GhiChu = '';
		}
	}
	export class DSFileImport extends BaseModel {
		listImport: FileImport[];

		clear() {
			this.listImport = [];
		}
	}
	export class FileImport extends BaseModel {
		idLoaiHH: number;
		base64: string;
		fileByte: any;
		filename: string;
		dienGiai: string;
		extension: string;

		clear() {
			this.idLoaiHH = 0;
			this.base64 = '';
			this.fileByte = null;
			this.filename = '';
			this.dienGiai = '';
			this.extension = '';
		}

		copy(item: FileImport) {
			this.idLoaiHH = item.idLoaiHH;
			this.base64 = item.base64;
			this.fileByte = item.fileByte;
			this.filename = item.filename;
			this.dienGiai = item.dienGiai;
			this.extension = item.extension;
		}
	}
	export class HangDiXuLy extends BaseModel{
		IdCtxk: number
		IdXk: number
		SoPhieu: string
		NgayXuat: string
		IdHh: number
		MaHang: string
		TenHang: string
		QuyCach: string
		Dvt: number
		TenDvt: string
		CanPhieuKT: boolean
		Soluongthucxuat: string
		IdPB: number

		clear(){
			this.IdCtxk = 0;
			this.IdXk = 0;
			this.SoPhieu = '';
			this.NgayXuat = '';
			this.IdHh = 0;
			this.MaHang = '';
			this.TenHang = '';
			this.QuyCach = '';
			this.Dvt = 0;
			this.TenDvt = '';
			this.CanPhieuKT = false;
			this.Soluongthucxuat = '';
			this.IdPB = 0;
		}

		copy(item: HangDiXuLy){
			this.IdCtxk = item.IdCtxk;
			this.IdXk = item.IdXk;
			this.SoPhieu = item.SoPhieu;
			this.NgayXuat = item.NgayXuat;
			this.IdHh = item.IdHh;
			this.MaHang = item.MaHang;
			this.TenHang = item.TenHang;
			this.QuyCach = item.QuyCach;
			this.Dvt = item.Dvt;
			this.TenDvt = item.TenDvt;
			this.CanPhieuKT = item.CanPhieuKT;
			this.Soluongthucxuat = item.Soluongthucxuat;
			this.IdPB = item.IdPB;
		}
	}
	export class HangDiXuLyVe extends BaseModel{
		IdTk: number
		IdKho: number
		TenKho: string
		IdHh: number
		TenHH: string
		MaHH: string
		QuyCach: string
		Soluong: string
		DungSai: number
		CanPhieuKT: boolean
		Dvt: number
		TenDvt: string
		IdLo: number
		Solo: string
		MaSub: string
		SoMay: string
		NgayNhapKho: string

		clear(){
			this.IdTk = 0;
			this.IdKho = 0;
			this.TenKho = '';
			this.IdHh = 0;
			this.TenHH = '';
			this.MaHH = '';
			this.QuyCach = '';
			this.DungSai = 0;
			this.CanPhieuKT = false;
			this.Soluong = DeNghiNhapKhoChiTiet.DEFAULT_NUMBER_VALUE_NUMBER;
			this.Dvt = 0;
			this.TenDvt = '';
			this.IdLo = 0;
			this.Solo = '';
			this.MaSub = '';
			this.SoMay = '';
			this.NgayNhapKho = '';
		}

		copy(item: HangDiXuLyVe){
			this.IdTk = item.IdTk;
			this.IdKho = item.IdKho;
			this.TenKho = item.TenKho;
			this.IdHh = item.IdHh;
			this.TenHH = item.TenHH;
			this.MaHH = item.MaHH;
			this.QuyCach = item.QuyCach;
			this.Soluong = item.Soluong;
			this.DungSai = item.DungSai;
			this.CanPhieuKT = item.CanPhieuKT;
			this.Dvt = item.Dvt;
			this.TenDvt = item.TenDvt;
			this.IdLo = item.IdLo;
			this.Solo = item.Solo;
			this.MaSub = item.MaSub;
			this.SoMay = item.SoMay;
			this.NgayNhapKho = item.NgayNhapKho;
		}
	}
